import React from 'react';
import './theme/index.scss';

type BranderProps = {
  children: React.ReactNode;
};

const Brander = ({ children }: BranderProps) => (
  <div className="raven-brander">{children}</div>
);

Brander.displayName = 'Brander';

export default Brander;
